import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipos de datos
export interface PerfilPuesto {
  id: string;
  nombre_puesto: string;
  departamento: string;
  competencias_requeridas: string | null;
  descriptor_url: string | null;
  descriptor_nombre: string | null;
  created_at: string;
  updated_at: string;
}

export interface Empleado {
  id: string;
  user_id: string | null;
  nombre_completo: string;
  email: string;
  telefono: string | null;
  perfil_puesto_id: string | null;
  departamento: string | null;
  fecha_ingreso: string | null;
  foto_url: string | null;
  cv_url: string | null;
  estado: string;
  cumplimiento_porcentaje: number;
  created_at: string;
  updated_at: string;
}

export interface Capacitacion {
  id: string;
  nombre_curso: string;
  descripcion: string | null;
  duracion_horas: number | null;
  instructor: string | null;
  modalidad: string | null;
  fecha_inicio: string | null;
  fecha_fin: string | null;
  estado: string;
  cupo_maximo: number | null;
  cupo_disponible: number | null;
  created_at: string;
  updated_at: string;
}

export interface Certificacion {
  id: string;
  empleado_id: string;
  nombre_certificacion: string;
  institucion: string | null;
  fecha_obtencion: string | null;
  fecha_vencimiento: string | null;
  numero_certificado: string | null;
  documento_url: string | null;
  estado: string;
  created_at: string;
  updated_at: string;
}

export interface Evaluacion {
  id: string;
  empleado_id: string;
  tipo: string;
  periodo: string | null;
  evaluador_nombre: string | null;
  calificacion: number | null;
  estado: string;
  fecha_evaluacion: string | null;
  comentarios: string | null;
  created_at: string;
  updated_at: string;
}

export interface Competencia {
  id: string;
  nombre: string;
  descripcion: string | null;
  categoria: string | null;
  nivel_requerido: number | null;
  created_at: string;
}

export interface NecesidadCapacitacion {
  id: string;
  empleado_id: string;
  tipo: string;
  descripcion: string | null;
  prioridad: string;
  estado: string;
  solicitado_por: string | null;
  fecha_solicitud: string | null;
  fecha_programada: string | null;
  created_at: string;
  updated_at: string;
}
